import React from 'react';
import styled from 'styled-components';
const SpaceForInfoI = styled.div `
  margin-right: 6px;
  flex: 0 0 24px;
  height: 24px;
  display: block;
`;
export const FinanceLayoutHelper = () => (React.createElement(SpaceForInfoI, { className: "fa-vtp-financing-infoi-placeholder" }));
